import styled, { css } from 'styled-components';
import { Heading } from '@bechtel/gds';

export const AttachmentHeadingStyled = styled(Heading)`
  ${({ theme }) => css`
    flex-grow: 1;
    font-size: ${theme.fontSizes[400]};
    font-family: ${theme.fontFamilies['graphik']};
    background: ${theme.colors.grey[200]};
    padding-bottom: ${theme.spacings[500]};
    padding-left: ${theme.spacings[500]};
    padding-right: ${theme.spacings[500]};
    padding-top: ${theme.spacings[600]};
    border: solid 1px ${theme.colors.grey[300]};
    color: ${theme.colors.grey[1000]};
  `}
`;
